import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { Alert } from '@mui/material'

import { useStores } from 'admin/hooks'
import Filter from './filter'
import HeatMap from './heatmap'
import Summary from './summary'
import FlowSankey from './flow-sankey'
import WeekdayCalendarHeatmap from './weekday-calendar-heatmap'
import DriverRouteDataGrid from './datagrid'
import AggregatedMovement from './aggregated'

const DriverRouteAnalysis = () => {
  const { reportStore } = useStores()
  const isAggregated = reportStore.driverRouteQuery.mode === 'aggregated'
  const visualizationMode = reportStore.driverRouteQuery.visualizationMode || 'all'
  const showCalendar = visualizationMode === 'all' || visualizationMode === 'calendar'
  const showFlow = visualizationMode === 'all' || visualizationMode === 'flow'
  const showTable = visualizationMode === 'all' || visualizationMode === 'table'
  const driverRouteQueryParamsKey = useMemo(
    () => JSON.stringify(reportStore.driverRouteQueryParams),
    [reportStore.driverRouteQueryParams],
  )

  useEffect(() => {
    const hasRequiredDates = Boolean(
      reportStore.driverRouteQuery.startDate && reportStore.driverRouteQuery.endDate,
    )

    if (!hasRequiredDates) {
      reportStore.clearDriverRouteReport()
      return
    }

    reportStore.fetchDriverRouteReport()
  }, [driverRouteQueryParamsKey])

  const reconciliation = reportStore.driverRouteReconciliation || {}
  const hasMismatch = (
    Number(reconciliation.stopTotal || 0) !== Number(reconciliation.summaryTotal || 0)
      || (isAggregated
        && reconciliation.aggregatedTraversalBasisTotal !== undefined
        && Number(reconciliation.aggregatedTraversalBasisTotal || 0)
          > Number(reconciliation.stopTotal || 0))
  )
  return (
    <>
      <Filter />
      {hasMismatch && (
        <Alert severity="warning">
          Reconciliation mismatch detected. stopTotal={reconciliation.stopTotal || 0}, summaryTotal=
          {reconciliation.summaryTotal || 0}
          {reconciliation.aggregatedTraversalBasisTotal !== undefined
            ? `, aggregatedTraversalBasisTotal=${reconciliation.aggregatedTraversalBasisTotal || 0}`
            : ''}
          . Please verify route filters and source data.
        </Alert>
      )}
      {!isAggregated && <Summary />}
      {showCalendar && !isAggregated && <WeekdayCalendarHeatmap />}
      {!isAggregated && <HeatMap />}
      {showFlow && <FlowSankey />}
      {isAggregated ? <AggregatedMovement /> : showTable && <DriverRouteDataGrid />}
    </>
  )
}

export default observer(DriverRouteAnalysis)
